// extracted by mini-css-extract-plugin
export default {"image":"ImageCard_image__3Fn5J"};